import { EMarketTypes } from "../../../../../../interfaces";
import { getAccessToken } from "../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import AuthModal from "../../../../auth/components/modals/authModal";
import ConfirmModal from "../../../../../shared/modals/confirmModal";
import useDealRequest, {
  EDealRequestType,
} from "../../../../../../api/hooks/use-deal-request";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface IFacilityCardBuyModal {
  id: number;
  opened: boolean;
  marketType: EMarketTypes;
  onClose: (value: boolean) => void;
  offsetY: number;
}

const FacilityCardBuyModal = ({
  id: facilityId,
  opened,
  onClose,
  marketType,
  offsetY,
}: IFacilityCardBuyModal) => {
  const { trigger, isMutating: isMutatingBuy } = useDealRequest();

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleBuy = async () => {
    if (getAccessToken()) {
      try {
        if (facilityId) {
          await trigger({
            data: {
              facilityId: facilityId,
            },
            marketType: marketType,
            type: EDealRequestType.Purchase,
          });
        }
        toast.success(
          "Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время."
        );
        onClose(false);
      } catch (error: any) {
        if (error.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      {openAuth && (
        <AuthModal
          opened={openAuth}
          onClose={() => handleChangeModalAuth(false)}
          offsetY={offsetYAuth}
        />
      )}
      <ConfirmModal
        title="Заявка на ПРОСМОТР"
        text="Вы уверены что хотите оставить заявку на просмотр?"
        opened={opened}
        onClose={() => onClose(false)}
        onClickRight={handleBuy}
        onClickLeft={() => onClose(false)}
        loading={isMutatingBuy}
        offsetY={offsetY}
      />
    </div>
  );
};

export default FacilityCardBuyModal;
